<template>
    <div class="nsoc">
      <Helmet>
        <title>Global NSOC - inte-QT</title>
        <meta name="title" content="Global NSOC - inte-QT" />
        <meta name="description"
              content="We provide Internet Access across the globe with 24X7 Network and Security Operations Center is operational every clock hour, and 365 days of the year." />
        <link rel="canonical" href="https://www.inte-qt.com/global-nsoc" />
      </Helmet>
  
      <img
        src="/images/fcNdSGt.jpg"
        alt="big-background"
        class="banner-img banner-img__black"
      />
      <h1 class="banner-img__header text-center">Global NSOC 24x7</h1>
  
      <div class="container-fluid">
        <div class="nsoc__aux">
          <div class="row">
            <div class="col-lg-6 col-md-12 nsoc__img-row">
              <img :src="socialmedia" alt="" class="text-center mt-4 nsoc__img-row__img" />
            </div>
            <div class="col-lg-6 col-md-12">
              <p class="nsoc__p">
                <i class="far fa-check-circle blue"></i>
                We live in the era of businesses driven by internet, applications and tools which help in increasing the effectiveness of workforce...
              </p>
              <p class="nsoc__p">
                <i class="far fa-check-circle blue"></i>
                The increasing importance of applications based on latest technologies...
              </p>
              <p class="nsoc__p">
                <i class="far fa-check-circle blue"></i>
                Operations across the Globe needs 24/7/365 NSOC (Network Security Operations Centre)...
              </p>
            </div>
          </div>
  
          <div align="justify">
            <h3 class="nsoc__p nsoc__slimheader text-center">
              inte-QT’s NSOC operates around the clock... 
              <span class="nsoc__pink">Robust</span>,
              <span class="nsoc__pink">Resilient</span>,
              <span class="nsoc__pink">Reliable</span>
            </h3>
            <div class="text-center">
              <img src="/images/WSZQMpb.png" alt="Points of our global nsoc team" class="nsoc__img-secondary" />
            </div>
  
            <h3 class="text-center nsoc__p nsoc__slimheader">
              NSOC processes includes end to end management...
            </h3>
            <div class="text-center">
              <img src="/images/FVpCGEE.png" alt="We serve" class="nsoc__img-secondary" />
            </div>
  
            <h3 class="nsoc__p nsoc__slimheader" align="justify">
              At our NSOC, SLA's are stringent and adhered to...
            </h3>
          </div>
        </div>
      </div>
  
      <img src="/images/rNiboOR.jpg" alt="handshaking" class="nsoc__bigimg" />
  
      <TestimonialCarousel />
      <EventsComponent />
      <ContactSupport />
      <GetInTouch />
    </div>
  </template>
  
  <script setup>
  import { onMounted } from 'vue'
  import { Helmet } from 'vue-helmet'
  import socialmedia from '@/data/social-media.svg'
  
  import GetInTouch from '@/components/GetInTouch.vue'
  import TestimonialCarousel from '@/components/TestimonialCarousel.vue'
  import EventsComponent from '@/components/EventsComponent.vue'
  import ContactSupport from '@/views/SupportPage.vue'
  
  onMounted(() => {
    window.scrollTo(0, 0)
  })
  </script>
  
  <style scoped >
  .nsoc {
  color: #000; /* $black */
  line-height: 1.5;
  font-size: 1.25rem; /* $font-xl */

  /* IMAGE BLOCK */
  /* &__img-secondary */
  .nsoc__img-secondary {
    width: 55vw;
    border-radius: 15px;
  }

  @media (max-width: 1200px) {
    .nsoc__img-secondary {
      width: 65vw;
    }
  }

  @media (max-width: 992px) {
    .nsoc__img-secondary {
      margin: 2rem;
      width: 100%;
    }
  }

  @media (max-width: 576px) {
    .nsoc__img-secondary {
      margin: 0;
    }
  }

  /* &__img-row */
  .nsoc__img-row {
    overflow: hidden;
  }

  @media (max-width: 1400px) {
    .nsoc__img-row {
      height: 50vh;
    }
  }

  @media (max-width: 1200px) {
    .nsoc__img-row {
      height: 70vh;
    }
  }

  @media (max-width: 992px) {
    .nsoc__img-row {
      height: 50vh;
    }
  }

  @media (max-width: 576px) {
    .nsoc__img-row {
      height: 100%;
    }
  }

  /* &__img-row__img */
  .nsoc__img-row__img {
    height: 100%;
  }

  @media (max-width: 1200px) {
    .nsoc__img-row__img {
      height: 100%;
    }
  }

  @media (max-width: 992px) {
    .nsoc__img-row__img {
      height: 50vh;
    }
  }

  /* &__header */
  .nsoc__header {
    color: #d3d3d3; /* $light-gray */
    position: absolute;
    width: 910px;
    top: 30vh;
    left: 10vw;
    line-height: 1.5;
    font-size: 6rem;
    font-weight: 500; /* $font-med */
    margin-left: 2rem;
  }

  @media (max-width: 576px) {
    .nsoc__header {
      font-weight: 700; /* $font-thick */
    }
  }

  @media (max-width: 992px) {
    .nsoc__header {
      font-size: 2rem;
      width: auto;
      top: 140px;
    }
  }

  /* &__aux */
  .nsoc__aux {
    margin: 2rem;
    padding: 5rem;
  }

  @media (max-width: 992px) {
    .nsoc__aux {
      margin: 0;
      padding: 0;
    }
  }

  /* &__p */
  .nsoc__p {
    text-align: justify;
    margin: 2rem 5rem;
  }

  @media (max-width: 1400px) {
    .nsoc__p {
      margin: 2rem 0;
    }
  }

  @media (max-width: 992px) {
    .nsoc__p {
      font-size: 1rem; /* $font-med */
    }
  }

  /* &__slimheader */
  .nsoc__slimheader {
    font-weight: 700; /* $font-thick */
  }

  /* &__bigimg */
  .nsoc__bigimg {
    width: 100vw;
  }

  /* &__pink */
  .nsoc__pink {
    color: #F017B5;
  }
}

</style>
  